import { useState, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import UiButton from "../button";
import TextInput from "../textinput/TextInput";
import Loader from "../loader";
import Web3 from "web3";

import ERC20ABI from "../../utils/abi/ERC20.json";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNetworkOptions } from "../../context/contractDataLoaderService";
import {
  PrimaryIssueManager,
  contractAddress,
} from "@verified-network/verified-sdk";
import {
  SuccessToast,
  FailureToast,
  ToastOptions,
  networks,
} from "../../utils/constants";
import { useAccount, useClient, useConnectorClient } from "wagmi";
import {
  getProvider,
  getProviderNetwork,
  getWeb3,
} from "../../utils/helpers/networks";
import {
  blinkCreateOrder,
  getAllVerifiedCashBalances,
} from "../../utils/helpers";
import { useGlobal } from "../../context/globalContext";
const { ethers, providers } = require("ethers");

function AcceptModal(props) {
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
    verifiedWalletDetails,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;

  const [loading, setLoading] = useState(false);
  const [subscribedAmount, setSubscribedAmount] = useState("");
  const [changeContent, setChangeContent] = useState(false);
  const modalContent = useRef(null);
  const { data: networkOptions } = useNetworkOptions();

  let primaryIssueManagerContract;
  if (address && chainId && provider && provider.getSigner) {
    const BalancerPrimaryIssueManager =
      contractAddress[chainId].BalancerPrimaryIssueManager;
    if (BalancerPrimaryIssueManager) {
      primaryIssueManagerContract = new PrimaryIssueManager(
        signer,
        BalancerPrimaryIssueManager,
        "balancer",
      );
    }
  }

  const acceptInvestor = async () => {
    if (subscribedAmount.length == 0) {
      toast.error("Enter proper subscribedAmount amount", ToastOptions);
      return;
    }
    if (Number(subscribedAmount) > Number(props.data.qty)) {
      toast.error("Enter amount less than subscribed amount", ToastOptions);
      return;
    }
    setLoading(true);

    const currencyTokenContract = new web3.eth.Contract(
      ERC20ABI,
      props.data.asset,
    );

    const tokenDecimals = await currencyTokenContract.methods.decimals().call();
    const subscribedAmountFixed = String(
      subscribedAmount * 10 ** tokenDecimals,
    );

    try {
      let paymentToken;

      if (
        verifiedWalletDetails &&
        Object?.keys(verifiedWalletDetails)?.length > 0
      ) {
        const cashTokens = await getAllVerifiedCashBalances(
          chainId,
          web3,
          account,
        );

        if (!cashTokens || cashTokens?.length === 0) {
          setLoading(false);
          toast.error(
            "No valid Cash Token on this network. Change network and try again.",
            ToastOptions,
          );

          return;
        }
        paymentToken = cashTokens[0];
        const txQuote = await primaryIssueManagerContract._getMeeQuote(
          cashTokens[0]?.address,
          "accept",
          [
            props.data.poolId,
            props.data.address,
            subscribedAmountFixed,
            props.data.asset,
          ],
        );

        if (
          Number(cashTokens[0]?.balance) === 0 ||
          Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
        ) {
          setLoading(false);
          toast.error(
            `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
            ToastOptions,
          );

          return;
        }
      }

      await primaryIssueManagerContract
        .accept(
          props.data.poolId,
          props.data.address,
          subscribedAmountFixed,
          props.data.asset,
          paymentToken?.address
            ? {
                paymentToken: paymentToken?.address,
                apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
              }
            : {},
        )
        .then((res) => {
          setLoading(false);
          if (res?.status === 0) {
            const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${res?.response?.hash}`;
            toast.success(SuccessToast(transactionLink), ToastOptions);
            setChangeContent(true);
            modalContent.current.innerHTML = "";
          } else {
            toast.error("Transaction Failed.", ToastOptions);
          }
        });
    } catch (err) {
      let error = { err };
      console.log(error);
      const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${error.err?.transactionHash}`;
      setLoading(false);
      toast.error(FailureToast(transactionLink), ToastOptions);
    }
  };

  return (
    <>
      {loading ? <Loader /> : null}
      {changeContent && (
        <UiButton
          onClick={() => {
            props.onModalHide();
          }}
          buttonVariant="primary"
          buttonClass="SignUpButton flex-1 ml-0"
          buttonText="Click to close this form&nbsp;&rarr;"
          type="submit"
        />
      )}
      <div className="d-grid gap-2" ref={modalContent}>
        <Row className="ml-1 align-items-center">
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Allotment amount</b>
            </Col>
            <Row>
              <Col className="pl-0" xs={5}>
                <TextInput
                  placeholder="Amount"
                  fieldType="number"
                  onChange={(e) => setSubscribedAmount(e.target.value)}
                  value={subscribedAmount}
                  required
                />
              </Col>
              <Col className="pl-0" xs={5}>
                <p
                  onClick={() => {
                    setSubscribedAmount(Number(props.data?.qty));
                  }}
                  style={{ color: "blue", cursor: "pointer" }}
                >
                  Max Amount
                </p>
              </Col>
            </Row>
          </Row>
          <Row className="mx-0 my-2 pl-0 width-100 align-items-center">
            <Col className="pl-0">
              <UiButton
                onClick={async () => {
                  if (web3 && account && chainId && signer) {
                    await acceptInvestor();
                  }
                }}
                buttonVariant="primary"
                buttonClass="SignUpButton flex-1 ml-0"
                buttonText="Accept"
                type="submit"
              />
            </Col>
          </Row>
        </Row>
      </div>
    </>
  );
}

export function AcceptInvestor(props) {
  return <AcceptModal {...props} />;
}
